// @ts-nocheck
import managementSystemRouter from '@/router/managementSystemRouter'

const routes = [{
  name: 'Home',
  path: '/',
  redirect: '/index',
  component: resolve => require(['@/views/layout'], resolve),
  meta: {},
  children: [{
    name: 'index',
    path: 'index',
    component: resolve => require(['@/views/map-view'], resolve),
    meta: { title: '首页', keepAlive: true }
  },
  {
    name: 'mapMoreDetails',
    path: '/mapMoreDetails/:id',
    component: resolve => require(['@/views/map-view/mapMoreDetails'], resolve),
    meta: { title: '更多详情' }
  }, {
    name: 'policiesRegulations',
    path: 'policiesRegulations',
    component: resolve => require(['@/views/policiesRegulations'], resolve),
    meta: { title: '政策法规' }
  }, {
    name: 'consultingServices',
    path: 'consultingServices',
    component: resolve => require(['@/views/consultingServices'], resolve),
    meta: { title: '咨询服务' }
  }]
}, {
  name: 'TimeOut',
  path: '/TimeOut',
  component: resolve => require(['@/views/common/TimeOut'], resolve),
  meta: {}
}, {
  name: 'login',
  path: '/login',
  component: resolve => require(['@/views/login'], resolve),
  meta: {
    title: '后台登录登录',
    ignoreAuth: true
  }
},
{
  name: 'appmapMoreDetails',
  path: '/appmapMoreDetails/:id',
  component: resolve => require(['@/views/map-view/appmapMoreDetails'], resolve),
  meta: { title: '更多详情' }
},
{
  name: 'mobileindex',
  path: '/mobileindex',
  component: resolve => require(['@/views/mobile-view/mobileIndex'], resolve),
  meta: { title: '移动端首页' }
},
{
  name: 'mobileMoreDetails',
  path: '/mobileMoreDetails/:id',
  component: resolve => require(['@/views/mobile-view/mobileMoreDetails'], resolve),
  meta: { title: '移动端更多详情' }
},
{
  name: 'mobilepoliciesRegulations',
  path: '/mobilepoliciesRegulations',
  component: resolve => require(['@/views/mobile-view/mobilepoliciesRegulations'], resolve),
  meta: { title: '移动端更多详情' }
},
managementSystemRouter, {
  name: '404',
  path: '*',
  component: resolve => require(['@/views/common/404'], resolve),
  meta: {}
}]

export default routes
